import handleQueryError from '../../../util/Common/Error/Handler/handleQueryError';
import serviceDefaultAPI from '../../api';

const logout = async ({ refresh }) => {
  try {
    const response = await serviceDefaultAPI.post(`sign/logout`, { refresh });
    return response;
  } catch (error) {
    throw new Error(handleQueryError({ error }));
  }
};

export default logout;
